import React, { useState } from "react";
import PropTypes from "prop-types";

import { Input, Field, Control, Label } from "rbx";
import FilterButtons from "../../../components/FilterButtons";

import {
  BooleanInput,
  StateSelect,
  SystemCodeMultipleSelect,
  EmployeeSelect
} from "../../../components/inputs";

const INITIAL_FILTER_STATE = {
  Active: true
};

const EmployeeFilters = ({ filters, onFilter, onClose }) => {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({
      ...inputs,
      [e.target.name]:
        e.target.name === "EmployeeTypeRecIdRef" ? parseInt(value) : value
    });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Field kind="group">
        <Control>
          <Label>Employee ID</Label>
          <Input
            autocomplete="new"
            name="EmployeeId_contains"
            type="text"
            value={inputs.EmployeeId_contains}
            onChange={handleChange}
          />
        </Control>

        <Control expanded>
          <Label>Last Name</Label>
          <Input
            autocomplete="new"
            name="LastName_contains"
            type="text"
            value={inputs.LastName_contains}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <Label>State</Label>
          <StateSelect
            name="State"
            value={inputs.State}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Driver</Label>
          <BooleanInput
            name="DriverFlag"
            value={inputs.DriverFlag}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Drug Test</Label>
          <BooleanInput
            name="DrugTest"
            value={inputs.DrugTest}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Mechanic</Label>
          <BooleanInput
            name="MechanicFlag"
            value={inputs.MechanicFlag}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <EmployeeSelect
            icon="globe"
            label="Supervisor"
            name="SupervisorRecIdRef"
            value={inputs.SupervisorRecIdRef}
            variables={{
              where: { EmployeeTypeRecIdRef: 96, Active: true },
              orderByMulti: ["LastName_ASC"]
            }}
            onChange={({ target: { name, value } }) =>
              value
                ? handleChange({ target: { name, value: parseInt(value, 10) } })
                : handleChange({ target: { name, value } })
            } // Executive Level
          />
        </Control>
        <Control expanded>
          <SystemCodeMultipleSelect
            label="Employee Type"
            lookup={{ Category: "Employee", Code: "EmployeeType" }}
            name="EmployeeTypeRecIdRef_in"
            showHelp={false}
            value={inputs.EmployeeTypeRecIdRef_in}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
};

EmployeeFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};

export default EmployeeFilters;
